export function capitalize(x: string) {
  if (x.length > 0) {
    const c = x.charAt(0);
    if (c >= "a" && c <= "z") {
      return c.toUpperCase() + x.slice(1);
    }
  }
  return x;
}
